import React from 'react';
import { useParams } from 'react-router-dom';
import { useAccountId } from '../../redux/slices/appInfo/hooks';
import { TypedMemo } from '../common/types';
import { LoadingView } from '../common/views/LoadingView';
import { FullScreenUpgradeHost } from '../music24/components/SMLUpgradeModal/FullScreenUpgradeHost';
import { CoverEditorScreen } from './CoverEditorScreen';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import styles from './CoverEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The cover editor route: `/app/catalog/song/:catalogItemUuid/cover` (design cover-editor b1). It
 * fills the screen: no app sidebar and no page head, only the editor with its own top bar. Every
 * call is account-scoped; the key starts a new editor for each artist and each song.
 */
const CoverEditorViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const { catalogItemUuid } = useParams<{ catalogItemUuid: string }>();
  return (
    <div className={styles.screen} data-fullscreen-editor>
      {accountId === null || catalogItemUuid === undefined ? (
        <LoadingView />
      ) : (
        <CoverEditorScreen
          key={`${accountId}:${catalogItemUuid}`}
          accountId={accountId}
          catalogItemUuid={catalogItemUuid}
        />
      )}
      {/* This route has no `SMLContainer`: the upgrade prompt and the plan picker need their own mount. */}
      <FullScreenUpgradeHost />
    </div>
  );
};

export const CoverEditorView = TypedMemo(CoverEditorViewComponent);
